module.exports = __webpack_public_path__ + "img/img_invite_friends_header.f02af188.png";